import { render, staticRenderFns } from "./journal-modal.vue?vue&type=template&id=58cf863d&scoped=true&"
import script from "./journal-modal.vue?vue&type=script&lang=js&"
export * from "./journal-modal.vue?vue&type=script&lang=js&"
import style0 from "./journal-modal.vue?vue&type=style&index=0&id=58cf863d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cf863d",
  null
  
)

export default component.exports